const readMenuIcon = (val, iconDefault) => {
    if(val === undefined || val === null || val === "") {
        return iconDefault;
    }

    return val;
};

export default readMenuIcon;